import React, { useState, useEffect } from 'react';
import { Tooltip } from 'antd';
import { siWhatsapp } from 'simple-icons';
import BrandIcon from './BrandIcon';

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '9805446865';
const WHATSAPP_MESSAGE = encodeURIComponent(
  'Hello! I have a question about your services at Current Care.',
);

const styles = {
  container: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  button: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    backgroundColor: '#25D366',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    color: '#fff',
    fontSize: 28,
    padding: 0,
  },
  popup: {
    backgroundColor: '#fff',
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    padding: '16px 20px',
    marginBottom: 12,
    maxWidth: 260,
    position: 'relative',
    animation: 'fadeIn 0.3s ease',
  },
  popupText: {
    margin: 0,
    fontSize: 14,
    color: '#333',
    lineHeight: 1.5,
  },
  popupTitle: {
    margin: '0 0 4px 0',
    fontSize: 15,
    fontWeight: 600,
    color: '#25D366',
  },
  closeBtn: {
    position: 'absolute',
    top: 4,
    right: 8,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: 16,
    color: '#999',
    padding: 0,
    lineHeight: 1,
  },
};

const WhatsAppButton = () => {
  const [showPopup, setShowPopup] = useState(true);

  // Greet once on load, then collapse to just the icon so it isn't intrusive.
  useEffect(() => {
    const timer = setTimeout(() => setShowPopup(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`,
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <div style={styles.container}>
      {showPopup && (
        <div style={styles.popup}>
          <button style={styles.closeBtn} onClick={() => setShowPopup(false)}>
            ×
          </button>
          <p style={styles.popupTitle}>Need help?</p>
          <p style={styles.popupText}>Chat with us on WhatsApp! We're here to help.</p>
        </div>
      )}
      <Tooltip title="Chat with us on WhatsApp" placement="left">
        <button
          style={styles.button}
          onClick={handleClick}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.1)';
            e.target.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.5)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 4px 12px rgba(37, 211, 102, 0.4)';
          }}
          aria-label="Chat on WhatsApp"
        >
          <BrandIcon icon={siWhatsapp} size={28} color="#fff" title="WhatsApp" />
        </button>
      </Tooltip>
    </div>
  );
};

export default WhatsAppButton;
